import { service } from '../axios';
export function login(data) {
    return service({ url: '/user/login', method: 'post', data });
}
export function userSave(data) {
    return service({ url: '/user/save', method: 'post', data });
}
export function deleteRecord(data) {
    return service({ url: '/user/delete', method: 'post', data });
}
export function currentSelfInfo(params) {
    return service({
        url: '/user/currentSelfInfo',
        method: 'get',
        params
    });
}
export function getAllUserNames(params) {
    return service({
        url: '/user/getAllUserNames',
        method: 'get',
        params
    });
}
export function getUserById(params) {
    return service({
        url: '/user/getUserById',
        method: 'get',
        params
    });
}
export function saveSelfInfo(data) {
    return service({ url: 'user/saveSelfInfo', method: 'post', data });
}
export function getUserPage(params) {
    return service({
        url: '/user/getPage',
        method: 'get',
        params
    });
}
export function getCurrentUser(params) {
    return service({
        url: '/user/currentUser',
        method: 'get',
        params
    });
}
export function userInfoSave(data) {
    return service({ url: 'user/save', method: 'post', data });
}
// Get User info
export function getUserInfo() {
    return service({
        url: '/user/currentUser',
        method: 'get'
    });
}
// User logout api
export function signout(data) {
    return service({
        url: '/user/signout',
        method: 'post',
        data
    });
}
